<template>
  <div class="animated fadeIn">
  <b-card no-body>
      <b-card-body fluid="xl">
        <b-form @submit.stop.prevent="onSubmit">
          <b-row>
            <b-col>
              <b-form-group label="Errors" v-if="showDismissibleAlert">
                  <b-alert variant="danger" :show="showDismissibleAlert"  @dismissed="showDismissibleAlert=false" dismissible fade>
                    <span v-for="items in submissionErros">
                      <ul v-for="item in items">
                        <li> {{item}} </li>
                      </ul>
                   </span>
                </b-alert>
             </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="From Time" label-for="fromTime">
                <b-form-timepicker id="fromTime" name="fromTime" :state="validateState('fromTime')"  aria-describedby="liveFeedbackFromTime" :show-seconds=true v-model.lazy.trim="$v.form.fromTime.$model" autofocus class="mb-2"  local="en" now-button reset-button></b-form-timepicker>
                <b-form-invalid-feedback id="liveFeedbackFromTime">
                   This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="To Time" label-for="toTime">
                <b-form-timepicker id="toTime" name="toTime" :state="validateState('toTime')"  aria-describedby="liveFeedbackToTime" :show-seconds=true v-model.lazy.trim="$v.form.toTime.$model" class="mb-2"  local="en" now-button reset-button></b-form-timepicker>
                <b-form-invalid-feedback id="liveFeedbackToTime">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
                Save
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
  </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { validationMixin } from "vuelidate";
  import {
    required
  } from "vuelidate/lib/validators"
  const formShape = {
    fromTime: null,
    toTime: null
  }
  export default {
    name: 'VisitHours',
    data() {
      return {
        form: Object.assign({}, formShape),
        submitted: false,
        showDismissibleAlert: false,
        showDismissibleAlert: false,
        submissionErros: "",
      }
    },
    validations: {
      form: {
        fromTime: {
          required
        },
        toTime: {
          required
        },
      }
    },
    computed: {
      isValid() {
        this.$v.$touch();
        return !this.$v.form.$anyError
      },
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      },
      validateTimes(dt1,dt2) {
    		var jdt1=Date.parse('20 Aug 2000 ' + dt1);
    		var jdt2=Date.parse('20 Aug 2000 ' + dt2);
    		if(isNaN(jdt1))
    		{
          this.showErrorMsg({
            message: "Invalid From Time."
          })
    			return false;
    		}
    		if(isNaN(jdt2))
    		{
          this.showErrorMsg({
            message: "Invalid To Time."
          })
    			return false;
    		}
    	  if (jdt1 >= jdt2)
    		{
          this.showErrorMsg({
            message: "From Time must be less than To Time."
          })
          return false;
    		}
        return true

	    },
      onSubmit(evt){
        console.log(JSON.stringify(this.form, null, 4));
        if(this.isValid && this.validateTimes(this.form.fromTime, this.form.toTime)){
          this.submitted = true;
          this.$refs.submitButton.disabled = false;
          this.showDismissibleAlert = false;
          this.$nextTick(() => {
              let params = JSON.stringify(this.form);
                this.$store.dispatch('samadh/updateVisitHours', params)
                  .then((response) => {
                    if(response.data.success == false){
                      this.showErrorMsg({
                        message: response.data.error
                      });
                      this.$refs.submitButton.disabled = false;
                    }
                    else{
                      this.showSuccessMsg({
                        message: 'Record Added successfully.'
                      });
                    }
                  })
                  .catch((error) => {
                    if (error.response.status == 400) {
                      this.showErrorMsg({
                        message: error.response.data.message
                      })
                    }
                    else if (error.response.status == 422){
                        this.showErrorMsg({
                          message: error.response.data.message
                        });
                        this.showDismissibleAlert=true;
                        var errors = Object.values(error.response.data.errors);
                        this.submissionErros = errors;
                    }
                    else {
                      this.showErrorMsg()
                    }
                    this.$refs.submitButton.disabled = false;
                  })
          });
        }
      },
    }
  }
</script>
